/**
 * DASHBOARD-PARTICIPATION.WIDGET
 * Statistics of participation for a survey
 */

import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import Card from "@/components/card"
import { SurveyState } from "@/redux/survey.types"
import { useEffect } from "react"
import { FilterState } from "@/redux/filter.types"
import { store } from "@/index"
import { loadParticipation } from "@/redux/_archive.actions"
import { STATUS_LOADING } from "@/redux/_status.types"
import { NavigateFunction, useNavigate } from "react-router-dom"
import DashboardParticipationOverviewWidget from "./dashboard-participation-overview.widget"
import DashboardParticipationMiniSkeletonWidget from "./skeletons/dashboard-participation-mini-skeleton.widget"

interface StateProps extends WithTranslation {
  filter: FilterState
  survey: SurveyState
}

interface OwnProps {
  isPreview?: boolean
}

type Props = StateProps & OwnProps

function DashboardParticipationMiniWidget(props: Props) {
  const navigate: NavigateFunction = useNavigate()

  //Load survey data on load
  useEffect(() => {
    store.dispatch(loadParticipation(props.filter.dashboard, props.isPreview))
  }, [props.filter.dashboard, props.survey.active.randomData, props.isPreview])

  const { t } = props
  return (
    <Card
      className="_hover flex1 flex flex-dcol"
      helpSection="participation"
      exportName={t("survey_participation")}
      title={t("survey_participation")}
      onClick={() => navigate("/dashboard/participation")}
      status={props.survey.status}
      isBreathing={props.survey.status === STATUS_LOADING}
      breatheVariant="glow"
      skeleton={<DashboardParticipationMiniSkeletonWidget />}>
      <DashboardParticipationOverviewWidget />
    </Card>
  )
}

const mapStateToProps = (state) => ({
  filter: state.filter,
  survey: state.survey
})

export default connect(mapStateToProps)(withTranslation()(DashboardParticipationMiniWidget))
